export default {
  getItem(key) {
    let cookie = document.cookie;
    let keyValues = cookie.split('; ');
    for (let i = 0; i < keyValues.length; i++) {
      let keyValue = keyValues[i];
      let index = keyValue.indexOf(key);
      if (index !== 0) {
        continue;
      }
      return keyValue.substring(key.length + 1);
    }
    return null;
  },
  setItem(key, config) {
    document.cookie = key + '=' + config;
  }
};



// WEBPACK FOOTER //
// ./src/common/storage/SessionManager.js